// src/components/ProductCard.jsx - TAM DÜZELTİLMİŞ VERSİYON

import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Star, Heart, Plus, Check, Info } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useWishlist } from '../context/WishlistContext';
import { openCartSidebar } from './CartSidebar';
import toast from 'react-hot-toast';

export default function ProductCard({ product, campaigns = [], viewMode = 'grid' }) {
  const navigate = useNavigate();
  const { addToCart, isInCart, items } = useCart();
  const { toggleWishlist, isInWishlist } = useWishlist();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isAdding, setIsAdding] = useState(false);

  const inCart = isInCart(product.id);
  const inWishlist = isInWishlist(product.id);

  // ✅ Ürüne uygulanan TÜM kampanyaları bul ve MİNİMUM TUTAR KONTROLÜ YAP
  const campaignAnalysis = useMemo(() => {
    const now = new Date();
    
    console.log('\n🔍 ===== KAMPANYA ANALİZİ =====');
    console.log('📦 Ürün:', product.name);
    console.log('💰 Ürün Fiyatı:', product.price);
    console.log('📂 Kategori:', product.category);
    
    // 1. Aktif kampanyaları filtrele
    const activeCampaigns = campaigns.filter(c => {
      if (c.discountType !== 'discount') return false;
      if (!c.endDate || c.endDate === 'null' || c.endDate === null) return true;
      const endDate = new Date(c.endDate);
      return endDate > now;
    });
    
    console.log('🎯 Aktif kampanya sayısı:', activeCampaigns.length);

    // 2. Ürüne uygulanabilir kampanyaları bul
    const applicableCampaigns = activeCampaigns.filter(campaign => {
      console.log(`\n  🔍 Kampanya: "${campaign.title}"`);
      console.log(`     Tip: ${campaign.campaignType}`);
      console.log(`     İndirim: %${campaign.discountPercent}`);
      console.log(`     Min: ${campaign.minPurchase}₺`);
      
      // ALT KATEGORİ KAMPANYASI
      if (campaign.campaignType === 'subcategory') {
        const targetFullPath = (campaign.targetName || campaign.targetCategory)?.trim();
        const productCategory = product.category?.trim();
        const matches = productCategory === targetFullPath;
        console.log(`     Alt kategori eşleşmesi: ${matches}`);
        return matches;
      }
      
      // ANA KATEGORİ KAMPANYASI
      if (campaign.campaignType === 'category' && campaign.targetCategory) {
        const productMainCategory = product.category.includes(' > ')
          ? product.category.split(' > ')[0].trim()
          : product.category.trim();
        
        const campaignMainCategory = campaign.targetCategory.trim();
        const matches = productMainCategory === campaignMainCategory;
        console.log(`     Ana kategori eşleşmesi: ${matches}`);
        return matches;
      }
      
      // ÜRÜN KAMPANYASI
      if (campaign.targetId && campaign.campaignType === 'product') {
        const matches = product.id === campaign.targetId;
        console.log(`     Ürün ID eşleşmesi: ${matches}`);
        return matches;
      }
      
      // GENEL KAMPANYA
      if (campaign.campaignType === 'general') {
        console.log(`     Genel kampanya: true`);
        return true;
      }
      
      return false;
    });

    console.log('\n✅ Uygulanabilir kampanya sayısı:', applicableCampaigns.length);

    if (applicableCampaigns.length === 0) {
      console.log('===== KAMPANYA ANALİZİ BİTTİ (kampanya yok) =====\n');
      return {
        bestCampaign: null,
        eligibleCampaign: null,
        notEligibleCampaign: null
      };
    }

    // 3. Her kampanya için minimum tutar kontrolü yap
    const campaignsWithEligibility = applicableCampaigns.map(campaign => {
      const minPurchase = campaign.minPurchase || 0;
      
      console.log(`\n  💰 "${campaign.title}" için minimum tutar kontrolü:`);
      
      // Bu kampanyaya uygun sepetteki ürünlerin toplamını hesapla
      let eligibleItemsTotal = 0;
      
      items.forEach(item => {
        let itemEligible = false;
        
        // ALT KATEGORİ KAMPANYASI
        if (campaign.campaignType === 'subcategory') {
          const targetFullPath = (campaign.targetName || campaign.targetCategory)?.trim();
          const itemCategory = item.category?.trim();
          itemEligible = itemCategory === targetFullPath;
        }
        // ANA KATEGORİ KAMPANYASI
        else if (campaign.campaignType === 'category' && campaign.targetCategory) {
          const itemMainCategory = item.category.includes(' > ')
            ? item.category.split(' > ')[0].trim()
            : item.category.trim();
          const campaignMainCategory = campaign.targetCategory.trim();
          itemEligible = itemMainCategory === campaignMainCategory;
        }
        // ÜRÜN KAMPANYASI
        else if (campaign.targetId && campaign.campaignType === 'product') {
          itemEligible = item.id === campaign.targetId;
        }
        // GENEL KAMPANYA
        else if (campaign.campaignType === 'general') {
          itemEligible = true;
        }
        
        if (itemEligible) {
          const itemPrice = item.currentPrice || item.price;
          const itemTotal = itemPrice * item.quantity;
          eligibleItemsTotal += itemTotal;
          console.log(`     ✅ ${item.name}: ${itemPrice}₺ x ${item.quantity} = ${itemTotal}₺`);
        }
      });
      
      // Bu ürün bu kampanyaya uygun mu?
      let currentProductEligible = false;
      
      if (campaign.campaignType === 'subcategory') {
        const targetFullPath = (campaign.targetName || campaign.targetCategory)?.trim();
        const productCategory = product.category?.trim();
        currentProductEligible = productCategory === targetFullPath;
      } else if (campaign.campaignType === 'category' && campaign.targetCategory) {
        const productMainCategory = product.category.includes(' > ')
          ? product.category.split(' > ')[0].trim()
          : product.category.trim();
        const campaignMainCategory = campaign.targetCategory.trim();
        currentProductEligible = productMainCategory === campaignMainCategory;
      } else if (campaign.targetId && campaign.campaignType === 'product') {
        currentProductEligible = product.id === campaign.targetId;
      } else if (campaign.campaignType === 'general') {
        currentProductEligible = true;
      }
      
      // Eğer bu ürün kampanyaya uygunsa ve sepette değilse, fiyatını ekle
      let checkTotal = eligibleItemsTotal;
      
      if (currentProductEligible && !inCart) {
        checkTotal += product.price;
        console.log(`     ➕ Bu ürün (sepette değil): ${product.price}₺`);
      }
      
      console.log(`     📊 Toplam uygun ürün tutarı: ${checkTotal.toFixed(2)}₺`);
      console.log(`     🎯 Minimum tutar: ${minPurchase}₺`);
      
      const isEligible = checkTotal >= minPurchase;
      const remainingAmount = isEligible ? 0 : minPurchase - checkTotal;
      
      console.log(`     ${isEligible ? '✅' : '❌'} Uygun mu? ${isEligible}`);
      if (!isEligible) {
        console.log(`     📌 Eksik tutar: ${remainingAmount.toFixed(2)}₺`);
      }
      
      return {
        campaign,
        isEligible,
        remainingAmount,
        eligibleTotal: checkTotal
      };
    });

    // 4. Minimum tutarı karşılayan kampanyalardan en yüksek indirimi seç
    const eligibleCampaigns = campaignsWithEligibility.filter(c => c.isEligible);
    
    console.log(`\n🎯 Minimum tutarı karşılayan kampanya sayısı: ${eligibleCampaigns.length}`);
    
    let bestEligibleCampaign = null;
    if (eligibleCampaigns.length > 0) {
      bestEligibleCampaign = eligibleCampaigns.reduce((max, current) => 
        current.campaign.discountPercent > max.campaign.discountPercent ? current : max
      );
      console.log(`✅ En iyi uygun kampanya: "${bestEligibleCampaign.campaign.title}" (%${bestEligibleCampaign.campaign.discountPercent})`);
    }

    // 5. Minimum tutarı karşılayamayan kampanyalardan en yüksek indirimi seç (bilgi için)
    const notEligibleCampaigns = campaignsWithEligibility.filter(c => !c.isEligible);
    
    let bestNotEligibleCampaign = null;
    if (notEligibleCampaigns.length > 0) {
      bestNotEligibleCampaign = notEligibleCampaigns.reduce((max, current) => 
        current.campaign.discountPercent > max.campaign.discountPercent ? current : max
      );
      console.log(`⏳ En iyi uygun olmayan kampanya: "${bestNotEligibleCampaign.campaign.title}" (%${bestNotEligibleCampaign.campaign.discountPercent}) - ${bestNotEligibleCampaign.remainingAmount.toFixed(2)}₺ eksik`);
    }

    console.log('===== KAMPANYA ANALİZİ BİTTİ =====\n');

    return {
      bestCampaign: bestEligibleCampaign || bestNotEligibleCampaign,
      eligibleCampaign: bestEligibleCampaign,
      notEligibleCampaign: bestNotEligibleCampaign
    };
  }, [campaigns, product.category, product.id, product.name, product.price, items, inCart]);

  // ✅ FİYAT HESAPLAMA - Kampanya analizine göre
  const displayPriceCalculation = useMemo(() => {
    const productPrice = product.currentPrice || product.price || 0;
    const productOriginalPrice = product.originalPrice || product.price || 0;

    const productDiscountPercent = productOriginalPrice > 0
      ? ((productOriginalPrice - productPrice) / productOriginalPrice * 100)
      : (product.discount || 0);

    const { eligibleCampaign, notEligibleCampaign } = campaignAnalysis;

    // Kampanya indirimi
    let campaignDiscountPercent = 0;
    let campaignEligible = false;
    let campaignMinPurchase = 0;
    let campaignRemainingAmount = 0;

    if (eligibleCampaign) {
      // Minimum tutarı karşılayan kampanya var
      campaignDiscountPercent = eligibleCampaign.campaign.discountPercent;
      campaignEligible = true;
      campaignMinPurchase = eligibleCampaign.campaign.minPurchase || 0;
      campaignRemainingAmount = 0;
    } else if (notEligibleCampaign) {
      // Minimum tutarı karşılamayan kampanya var
      campaignMinPurchase = notEligibleCampaign.campaign.minPurchase || 0;
      campaignRemainingAmount = notEligibleCampaign.remainingAmount;
    }

    const maxDiscount = Math.max(productDiscountPercent, campaignDiscountPercent);

    if (maxDiscount > 0) {
      const finalPrice = productOriginalPrice * (1 - maxDiscount / 100);
      return {
        originalPrice: productOriginalPrice,
        finalPrice: finalPrice,
        displayDiscount: maxDiscount,
        hasDiscount: true,
        discountSource: campaignDiscountPercent > productDiscountPercent ? 'campaign' : 'product',
        appliedCampaign: eligibleCampaign?.campaign || null,
        campaignNotEligible: !!notEligibleCampaign && !eligibleCampaign,
        campaignRemainingAmount: campaignRemainingAmount,
        campaignMinPurchase: campaignMinPurchase,
        displayCampaignPercent: eligibleCampaign?.campaign.discountPercent || notEligibleCampaign?.campaign.discountPercent || 0
      };
    }

    return {
      originalPrice: productOriginalPrice,
      finalPrice: productPrice,
      displayDiscount: 0,
      hasDiscount: false,
      discountSource: null,
      appliedCampaign: null,
      campaignNotEligible: !!notEligibleCampaign,
      campaignRemainingAmount: campaignRemainingAmount,
      campaignMinPurchase: campaignMinPurchase,
      displayCampaignPercent: notEligibleCampaign?.campaign.discountPercent || 0
    };
  }, [
    product.currentPrice,
    product.originalPrice,
    product.price,
    product.discount,
    campaignAnalysis
  ]);

  const {
    originalPrice,
    finalPrice,
    displayDiscount,
    hasDiscount,
    discountSource,
    appliedCampaign: finalAppliedCampaign,
    campaignNotEligible,
    campaignRemainingAmount,
    campaignMinPurchase,
    displayCampaignPercent
  } = displayPriceCalculation;

  const handleAddToCart = (e) => {
    e.stopPropagation();
    if (inCart) {
      openCartSidebar();
      return;
    }
    setIsAdding(true);

    const productForCart = {
      ...product,
      originalPrice: product.originalPrice || product.price,
      currentPrice: product.currentPrice || product.price,
      price: product.currentPrice || product.price,
      discount: product.discount || 0,
      shippingFee: Number(product.shippingFee) || 0,
      _hasActiveCampaign: !!finalAppliedCampaign,
    };

    addToCart(productForCart);
    toast.success(`${product.name} sepete eklendi!`);
    setTimeout(() => setIsAdding(false), 500);
  };

  const handleWishlistToggle = (e) => {
    e.stopPropagation();
    toggleWishlist(product);
    toast.success(inWishlist ? 'Favorilerden çıkarıldı' : 'Favorilere eklendi');
  };

  // List View
  if (viewMode === 'list') {
    return (
      <article className="product-card-list" onClick={() => navigate(`/product/${product.id}`)}>
        <div className="card-image">
          {(hasDiscount || campaignNotEligible) && (
            <div className={`discount-badge ${campaignNotEligible ? 'not-eligible' : ''}`}>
              %{Math.round(hasDiscount ? displayDiscount : displayCampaignPercent)}
              {finalAppliedCampaign && <span className="campaign-indicator"> 🎉</span>}
              {campaignNotEligible && <span className="campaign-indicator"> ⏳</span>}
            </div>
          )}
          {campaignNotEligible && (
            <div className="campaign-notice-badge">
              <Info size={12} />
              Min. {campaignMinPurchase}₺
            </div>
          )}
          {!imageLoaded && <div className="image-skeleton"></div>}
          <img
            src={product.image}
            alt={product.name}
            onLoad={() => setImageLoaded(true)}
            style={{
              display: imageLoaded ? 'block' : 'none',
              objectFit: 'contain',
              background: '#fff'
            }}
          />
        </div>
        <div className="card-content">
          <h3>{product.name}</h3>
          <p>{product.description || 'Açıklama yok'}</p>

          {product.rating !== 0 && (
            <div className="rating">
              <Star size={14} fill="#ffc107" stroke="#ffc107" />
              <span>{product.rating}</span>
            </div>
          )}
        </div>
        <div className="card-actions">
          <div className="price">
            {hasDiscount && (
              <span className="old">{originalPrice.toFixed(2)}₺</span>
            )}
            <span className="current">{finalPrice.toFixed(2)}₺</span>
            {finalAppliedCampaign && (
              <span className="campaign-label success">🎁 Kampanyalı</span>
            )}
            {campaignNotEligible && (
              <span className="campaign-label warning">
                📌 {campaignRemainingAmount.toFixed(0)}₺ daha
              </span>
            )}
            {discountSource === 'product' && hasDiscount && !finalAppliedCampaign && (
              <span className="campaign-label">💰 İndirimli</span>
            )}
          </div>
          <div className="buttons">
            <button
              className={`cart-btn ${inCart ? 'in-cart' : ''} ${isAdding ? 'adding' : ''}`}
              onClick={handleAddToCart}
            >
              {inCart ? <Check size={18} /> : <Plus size={18} />}
            </button>
            <button
              className={`wish-btn ${inWishlist ? 'active' : ''}`}
              onClick={handleWishlistToggle}
            >
              <Heart size={18} fill={inWishlist ? '#E5332A' : 'none'} color={inWishlist ? '#E5332A' : '#868e96'} />
            </button>
          </div>
        </div>
      </article>
    );
  }

  // Grid View (default)
  return (
    <article className="product-card" onClick={() => navigate(`/product/${product.id}`)}>
      {(hasDiscount || campaignNotEligible) && (
        <div className={`discount-badge ${campaignNotEligible ? 'not-eligible' : ''}`}>
          %{Math.round(hasDiscount ? displayDiscount : displayCampaignPercent)}
          {finalAppliedCampaign && <span className="campaign-indicator"> 🎉</span>}
          {campaignNotEligible && <span className="campaign-indicator"> ⏳</span>}
        </div>
      )}

      {campaignNotEligible && (
        <div className="campaign-notice-badge">
          <Info size={12} />
          <span>Min. {campaignMinPurchase}₺</span>
        </div>
      )}

      <button
        className={`wishlist-btn ${inWishlist ? 'active' : ''}`}
        onClick={handleWishlistToggle}
      >
        <Heart size={18} fill={inWishlist ? '#E5332A' : 'none'} color={inWishlist ? '#E5332A' : '#2B2B2B'} />
      </button>

      <div className="product-image">
        {!imageLoaded && <div className="image-skeleton"></div>}
        <img
          src={product.image}
          alt={product.name}
          onLoad={() => setImageLoaded(true)}
          style={{
            display: imageLoaded ? 'block' : 'none',
            objectFit: 'contain',
            background: '#fff',
            padding: '8px'
          }}
        />
      </div>

      <div className="product-info">
        <div className="product-brand">{product.name}</div>

        <div className='product-desc' style={{
          color: '#2B2B2B',
          fontSize: '0.8rem',
          marginBottom: '0.75rem',
          lineHeight: '1.4',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {product.description && product.description.includes('-') ? (
            product.description.split('\n').map((line, index) => (
              <div key={index}>{line}</div>
            ))
          ) : (
            product.description || 'Açıklama yok'
          )}
        </div>

        {product.rating !== 0 && (
          <div className="product-rating">
            <Star size={14} fill="#ffc107" stroke="#ffc107" />
            <span>{product.rating}</span>
          </div>
        )}

        <div className="product-footer">
          <div className="product-price">
            {hasDiscount && (
              <span className="old-price">
                {originalPrice.toFixed(2)}₺
              </span>
            )}
            <span className="current-price">{finalPrice.toFixed(2)}₺</span>

            {finalAppliedCampaign && (
              <span className="campaign-label success">🎁 Kampanyalı</span>
            )}

            {campaignNotEligible && (
              <span className="campaign-label warning">
                📌 {campaignRemainingAmount.toFixed(0)}₺ daha
              </span>
            )}

            {discountSource === 'product' && hasDiscount && !finalAppliedCampaign && (
              <span className="campaign-label">💰 İndirimli</span>
            )}
          </div>
          <button
            className={`add-cart-btn ${inCart ? 'in-cart' : ''} ${isAdding ? 'adding' : ''}`}
            onClick={handleAddToCart}
          >
            {inCart ? <Check size={16} /> : <Plus size={16} />}
          </button>
        </div>
      </div>

      <style jsx>{`
        .discount-badge.not-eligible {
          background: rgba(245, 158, 11, 0.95);
          border: 2px solid rgba(245, 158, 11, 0.6);
        }

        .campaign-notice-badge {
          position: absolute;
          top: 44px;
          left: 8px;
          background: rgba(245, 158, 11, 0.95);
          color: #fff;
          padding: 4px 8px;
          border-radius: 6px;
          font-size: 10px;
          font-weight: 700;
          z-index: 2;
          display: flex;
          align-items: center;
          gap: 4px;
          backdrop-filter: blur(4px);
        }

        .campaign-label.warning {
          background: rgba(245, 158, 11, 0.1);
          color: #f59e0b;
          border: 1px solid rgba(245, 158, 11, 0.3);
        }

        .campaign-label.success {
          background: rgba(6, 214, 160, 0.1);
          color: #06d6a0;
          border: 1px solid rgba(6, 214, 160, 0.3);
        }
      `}</style>
    </article>
  );
}